export default class StickyNavigation {
	private readonly offsetContainer: HTMLDivElement;
	private readonly stickyNavigation: HTMLDivElement;
	private readonly links: NodeListOf<HTMLAnchorElement>;

	constructor() {
		this.offsetContainer = document.querySelector('main > *:not([popover])');
		this.stickyNavigation = document.querySelector('header#sticky');

		if (this.offsetContainer && this.stickyNavigation) {
			this.links = this.stickyNavigation.querySelectorAll('a');
			window.addEventListener('scroll', () => this.onScroll(), { passive: true });
			this.updateTabIndex(false);
			this.onScroll();
		}
	}

	private updateTabIndex(active: boolean): void {
		this.links.forEach((link: HTMLAnchorElement) => {
			link.tabIndex = active ? 1 : -1;
		});
	}

	private onScroll(): void {
		const rect: DOMRect = this.offsetContainer.getBoundingClientRect();
		if (rect.height + rect.top > 0) {
			this.stickyNavigation.classList.remove('is-visible');
			this.updateTabIndex(false);
		} else {
			this.stickyNavigation.classList.add('is-visible');
			this.updateTabIndex(true);
		}
	}
}
